import { useState } from "react";
import {
  Transactions,
  TransactionsAccordionStates,
} from "react-migration/domains/comparables/components/Results/Transactions";
import { IComparablesTransactionDTO } from "react-migration/lib/typings/comparables/Comparables";

interface TransactionsAccordionProps {
  includedResults: IComparablesTransactionDTO[];
  loading: boolean;
  setSelectedRecord: (record: IComparablesTransactionDTO | undefined) => void;
}

export function TransactionsAccordion({ includedResults, loading, setSelectedRecord }: TransactionsAccordionProps) {
  const [transactionAccordionState, setTransactionAccordionState] = useState(TransactionsAccordionStates.CLOSED);

  return (
    <Transactions
      accordionState={transactionAccordionState}
      setAccordionState={setTransactionAccordionState}
      includedResults={includedResults}
      loading={loading}
      setSelectedRecord={setSelectedRecord}
    />
  );
}
